import React from "react";

const Outlines = ({ targets, strokeWidth }) => (
  <>
    {Object.entries(targets).reduce(
      (
        outlines,
        [
          key,
          {
            bounds: { left, top, right, bottom },
          },
        ],
        _,
        arr
      ) => {
        arr.length > 1 &&
          outlines.push(
            <rect
              key={key}
              className="transformer-target-outline"
              strokeWidth={strokeWidth}
              x={left}
              y={top}
              width={right - left}
              height={bottom - top}
            />
          );
        return outlines;
      },
      []
    )}
  </>
);

export default Outlines;
